import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AuthProvider } from "./contexts/AuthContext";
 import ProtectedRoute from "./component/ProtectedRoute";
import Login from "./page/Login";
import Dashboard from "./page/Dashboard";
 import "./App.css";

// Load test utilities in development
if (process.env.NODE_ENV === "development") {
  import("./utils/authTest");
  // import('./utils/connectivityTest');
  // import('./utils/authDebug');
  // import('./utils/privacyPolicyTest');
 }

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
           <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />

             
 
              <Route
                path="/dashboard/*"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Router>
       </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
